// MyAgent LLM SDK - Main Entry Point

import { createGeminiClient } from './client/gemini/index.js'
import type { HttpRequest } from './client/http.js'
import { createOllamaClient } from './client/ollama/index.js'
import { createOpenaiClient } from './client/openai/index.js'

import { type UnifiedInterface, createUnifiedInterface } from './unify/llm/base.js'
import type { ProviderName } from './unify/llm/model-metadata.js'
import { setAvailableProviders } from './unify/llm/model-selector.js'
import { createProviders } from './unify/llm/providers.js'

export interface CreateLlmSdkOptions {
  httpClient: HttpRequest
  availableProviders?: ProviderName[]
}

export type LlmSdk = UnifiedInterface

export default function createLlmSdk({
  httpClient,
  availableProviders: configuredProviders = [],
}: CreateLlmSdkOptions): LlmSdk {
  if (!httpClient || typeof httpClient !== 'function') {
    throw new Error('httpClient is required and must be a function')
  }

  const openaiClient = createOpenaiClient(httpClient)
  const geminiClient = createGeminiClient(httpClient)
  const ollamaClient = createOllamaClient(httpClient)

  const providers = createProviders({ openaiClient, geminiClient, ollamaClient })

  const unified = createUnifiedInterface(providers)

  if (configuredProviders.length > 0) {
    setAvailableProviders(configuredProviders)
  }

  return unified
}
